// Cart Summary
<template>

    <div class="lms5050 container whitesmoke curved">
        <div class="content board whitesmoke">


          <div class="text-center mb-2" >
            <sym-combo v-model="regionId" :input-width="68" display-field="regionFullName" :datasource="regions" @changing="onRegionIdChanging" @changed="onRegionIdChanged"></sym-combo>
          </div>


          <div class="d-flex justify-center align-items-center primary-light border-main p-1 curved mb-2" v-if="!hasItem && !regionId==0">
            <span class="lg-1"><i class="fa fa-info-circle fa-lg mr-2"></i>No cart found.</span>
          </div>
<!-- 
          <div class="text-center my-3">
            <button type="button" class="cart-button success text-center lg-2" v-show="hasItem" @click="showCart()" :disabled="!hasItem"><i class="fa fa-shopping-cart fa-lg mr-2"></i>Cart ({{ cartItems.length }}) </button>
          </div> -->

 <button type="button" class="primary text-center w-100 lg-1 shadow mt-3 mb-2" @click="goBack()"><i class="fa fa-arrow-left mr-2"></i> Back</button>

        </div>
    </div>

</template>

<script>

import {
  get
} from '../../js/http';

import
  * as lams
from '../../js/lams';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms5050',

  data () {
    return {
      regions: [],
      regionId: 0,

      cartKey: '',
      cartItems: [],
    }
  },

  computed: {

    hasItem () {
      if (this.cartItems.length > 0) {
        return true;
      }
    },


  },

  methods: {


    showCart () {
      const me = this;

      let route = {
        name: 'lms5030',
        params: {
          regionId: me.regionId
        }
      };
      this.go(route);
    },


    getRegions () {
      return get('api/accounts/' + this.accountCode + '/regions');
    },

    getLinkStatus (regionId) {
      return get('api/regions/' + regionId + '/link-status');
    },


    onRegionIdChanging (e) {
      const me = this;

      me.cartItems=[];

      let regionInfo = me.regions.find( obj => obj.regionId === e.proposedValue );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }

    },

    regionIdCallback (e) {
      const
        me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        statusCode => {
          me.stopWait(wait);

          let isOnline = (statusCode === 200);
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;

        }
      );

    },

    getLocalStorage () {
      const me = this;
      let info = me.getLocalItem(me.cartKey);

      if (info) {
        me.cartItems = info;
      }
    },

    onRegionIdChanged () {
      const me = this;



      if (!me.regionId) {
        me.apps = [];
        me.isListLoaded = false;
        return;
      }

    me.cartKey = me.sym.userInfo.accountCode + '*' + me.regionId + '*CART';
    me.getLocalStorage();

      if (me.cartItems.length > 0) {
        me.showCart();
      }

    },

  },

  created () {

  },

  mounted () {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode;


    me.regions = lams.getRegionList().filter(o => o.apiHostAddress);

    me.regions.unshift(
      { regionId: 0, regionFullName: '--- Select Region ---' }
    )

  },

}
</script>

<style scoped>

</style>